const Cart = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3L3.81045 3.46841C3.92598 3.48766 4.01974 3.57239 4.05056 3.68539L4.68182 6M7 13.5V16.7C7 16.8657 7.13431 17 7.3 17H16.5M7 13.5H17.7969C17.9196 13.5 18.0299 13.4253 18.0754 13.3114L20.8354 6.41142C20.9143 6.21436 20.7691 6 20.5569 6H4.68182M7 13.5L4.68182 6M16.5 17C15.3954 17 14.5 17.8954 14.5 19C14.5 20.1046 15.3954 21 16.5 21C17.6046 21 18.5 20.1046 18.5 19C18.5 17.8954 17.6046 17 16.5 17ZM11.5 19C11.5 20.1046 10.6046 21 9.5 21C8.39543 21 7.5 20.1046 7.5 19C7.5 17.8954 8.39543 17 9.5 17C10.6046 17 11.5 17.8954 11.5 19Z"
        stroke="#BABABA"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Cart;
